// extracted by mini-css-extract-plugin
module.exports = {"container":"Sidebar_container__69E6B","content":"Sidebar_content__zy4Kp","title":"Sidebar_title__3QMq3","closeButton":"Sidebar_closeButton__ErezD"};